<aside class="sidebar" [class.open]="open">
  <div class="brand">
    <div class="mark">T</div>
    <div>
      <div class="wm">Trexa</div>
      <span class="tag">ESCROW</span>
    </div>
  </div>

  <nav class="nav">
    <button class="navitem"
            type="button"
            [class.on]="isActive('/vendor/dashboard')"
            (click)="go('/vendor/dashboard')">
      <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 3l9 8h-3v9h-4v-6h-4v6H6v-9H3z"/></svg>
      Dashboard
    </button>
    <button class="navitem"
            type="button"
            [class.on]="isActive('/vendor/bookings')"
            (click)="go('/vendor/bookings')">
      <svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 1v2h6V1h2v2h2a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h2V1h2zm12 8H5v10h14V9z"/></svg>
      Booking
    </button>
    <button class="navitem"
            type="button"
            [class.on]="isActive('/vendor/wallet')"
            (click)="go('/vendor/wallet')">
      <svg viewBox="0 0 24 24" fill="currentColor"><path d="M21 7H5a1 1 0 010-2h14a1 1 0 000-2H5a3 3 0 00-3 3v12a3 3 0 003 3h16a1 1 0 001-1V8a1 1 0 00-1-1zm-3 8a2 2 0 110-4 2 2 0 010 4z"/></svg>
      Wallet
    </button>
    <button class="navitem"
            type="button"
            [class.on]="isActive('/vendor/services')"
            (click)="go('/vendor/services')">
      <svg viewBox="0 0 24 24" fill="currentColor"><path d="M4 4h16v4H4zm0 6h16v10H4z"/></svg>
      My Services
    </button>
    <button class="navitem"
            type="button"
            [class.on]="isActive('/vendor/website')"
            (click)="go('/vendor/website')">
      <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zm7.9 9h-3.6a15.7 15.7 0 00-1.2-5.4A8 8 0 0119.9 11zM12 4c.9 1.1 2 3.3 2.3 7H9.7C10 7.3 11.1 5.1 12 4zM4.1 11a8 8 0 014.8-5.4A15.7 15.7 0 007.7 11H4.1zm0 2h3.6a15.7 15.7 0 001.2 5.4A8 8 0 014.1 13zM12 20c-.9-1.1-2-3.3-2.3-7h4.6c-.3 3.7-1.4 5.9-2.3 7zm2.3-9H9.7a13.8 13.8 0 011.2-5.7c.4-.1.7-.1 1.1 0a13.8 13.8 0 011.2 5.7zm.1 7.4a15.7 15.7 0 001.2-5.4h3.6a8 8 0 01-4.8 5.4z"/></svg>
      Website
    </button>
    <button class="navitem"
            type="button"
            style="justify-content:space-between"
            [class.on]="isActive('/vendor/partners')"
            (click)="go('/vendor/partners')">
      <span style="display:flex;align-items:center;gap:11px">
        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M16 11a4 4 0 10-4-4 4 4 0 004 4zm-8 0a4 4 0 10-4-4 4 4 0 004 4zm0 2c-3 0-6 1.5-6 4v3h8v-3c0-1 .4-1.9 1-2.6A9 9 0 008 13zm8 0c-.7 0-1.4.1-2 .2 1.2.9 2 2.1 2 3.8v3h6v-3c0-2.5-3-4-6-4z"/></svg>
        Partnerships
      </span>
      <span class="badge amber" *ngIf="mv.pendingPartnerCount()">{{ mv.pendingPartnerCount() }}</span>
    </button>
  </nav>

  <div class="sidefoot">
    <div class="mecard">
      <div class="lab">Managing</div>
      <div class="nm">{{ mv.name() || '—' }}</div>
      <div class="sub">{{ mv.sub() }}</div>
      <!-- Switch vendor: only when the user is linked to MORE THAN ONE vendor. -->
      @if (mv.canSwitch()) {
        <button class="sw-btn" (click)="onSwitchVendor()">Switch vendor</button>
      }
      <!-- Admin console: platform-admin only (a vendor_owner never sees it). -->
      @if (personaSvc.hasRole('super_admin', 'tenant_admin')) {
        <button class="sw-btn" style="margin-top:7px" (click)="openAdminConsole()">Admin console →</button>
      }
      <button class="sw-btn" style="margin-top:7px" (click)="logout()">Log out</button>
    </div>
  </div>
</aside>
